export default __webpack_public_path__ + "static/media/gurantee.b8f3d8fa.gif";